<template>
  <div class="integration-wrapper mx-8">
    <div class="d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          class="keap-integration-logo"
          contain
          :alt="title"
          :max-width="60"
          :src="logo"
        />
        <h2 style="line-height:85px;" class="mr-3">
          {{ title }}
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          class="text-right mt-3"
          icon
          @click.stop="$store.commit('ui/drawer.right.toggle')"
        >
          <v-icon style="background-color:transparent" medium>
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="intergration-details-header">
      <v-card outlined class="update-card mb-5">
        <v-row class="px-3 pt-3">
          <v-col cols="1">
            <v-icon color="#3FD06F" class="mr-3" style="font-size:35px;">
              mdi-checkbox-marked-circle
            </v-icon>
          </v-col>
          <v-col class="ml-1">
            <v-row>
              <h2>{{ subHeading }}</h2>
            </v-row>
            <v-row class="mt-2 pr-2">
              {{ updateText }}
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div class="intergration-details-wrapper">
      <h2>Integration Settings</h2>
      <!-- Renders integrations name and values -->
      <div class="mt-5 py-2 px-3 bg-grey">
        <slot name="integrationInfo"></slot>
        <template v-if="hasIntergrationInfo">
          <v-row
            class="py-1"
            v-for="(value, name) in integrationInfo"
            :key="name"
          >
            <v-col cols="3" class="py-0 text--secondary subtitle-2">
              {{ name }}
            </v-col>
            <v-col class="py-0 body-1">{{ value }} </v-col>
          </v-row>
        </template>
        <v-row v-if="showStatus">
          <v-col
            cols="3"
            class="py-0 d-flex align-center text--secondary subtitle-2"
          >
            Status
          </v-col>
          <v-col class="py-0">
            <v-chip
              small
              outlined
              dark
              class="mt-1 mr-3"
              :color="storeData.active ? '#41CE65' : '#FFB933'"
            >
              {{ storeData.active ? "Active" : "Processing" }}
            </v-chip>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="integration-data-fields-wrapper">
      <h2 class="py-4" v-text="fieldsTitle" />
      <!-- Render intergration data fields -->
      <slot name="dataFields" />
    </div>
  </div>
</template>

<script>
/**
 * Integrations details drawer wrapper
 * @author {Jatin Kamboj}
 */
export default {
  name: "IntergrationDetailsDrawerWrapper",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    logo: { type: String, default: "" },
    title: { type: String, default: "" },
    subHeading: { type: String, default: "" },
    updateText: { type: String, default: "" },
    fieldsTitle: { type: String, default: "" },
    integrationInfo: { type: Object, default: () => ({}) },
    showStatus: { type: Boolean, default: true },
    storeData: {
      type: Object,
      required: true,
      default: () => ({ active: false })
    }
  },

  /**
  |--------------------------------------------------
  | Computed Properties
  |--------------------------------------------------
  */
  computed: {
    /**
     * Determines that itegration object has value or not
     */
    hasIntergrationInfo() {
      return (
        this.integrationInfo && Object.keys(this.integrationInfo).length > 0
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-grey {
  background-color: #f4f4f4;
}
.update-card {
  border: 4px solid #3bcf6c !important;
}
.field-table {
  border: 4px solid rgba(0, 0, 0, 0.12);
}
</style>
